<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='请假管理' url='/cycle/leave/list'></SearchTitle>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <div style="float: left;margin-top: 10px;display: none;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">管理单元：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.secretarysec" filterable placeholder="全部" @change="ManageSecChange">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in managesecOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;display: none;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">轮转科室：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.leavesec" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in secOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <SearchNormalText v-model='condition.stuname' label='姓名'></SearchNormalText>
          <SearchNormalText v-model='condition.stuno' label='工号'></SearchNormalText>
          <ZPGLSearchDictItemSelect v-model='condition.stuspec' label='专业' :dictid='this.$utils.DictEnum.specialty'></ZPGLSearchDictItemSelect>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
          <AddButton url="/cycle/leave/add" buttonname="新增"></AddButton>
          <!-- <el-button type="primary" icon="el-icon-search" @clisck="UpdateLeaveState">数据调整</el-button> -->
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
            <el-table-column prop="StuName" label="姓名">
            </el-table-column>
            <el-table-column prop="StuNo" label="工号">
            </el-table-column>
            <el-table-column prop="SpecName" label="专业">
            </el-table-column>
            <!-- <el-table-column prop="ManageSecName" label="请假管理单元">
            </el-table-column>
            <el-table-column prop="SecName" label="请假轮转科室">
            </el-table-column> -->
            <el-table-column label="请假时间" width="150">
              <template slot-scope="scope">
                {{scope.row.LeaveBeginDate|formatDate}}<br>{{scope.row.LeaveEndDate|formatDate}}
              </template>
            </el-table-column>
            <el-table-column prop="LeaveReason" label="请假原因">
            </el-table-column>
            <el-table-column prop="LeaveDay" label="请假天数">
            </el-table-column>
            <el-table-column prop="LeaveDayCount" label="请假总天数" width="100">
            </el-table-column>
            <el-table-column label="请假凭据" width="80">
              <template slot-scope="scope">
                <el-button v-if="scope.row.LeaveFile != null" @click="See(scope.row)" type="text" size="medium">查看</el-button>
                <div v-if="scope.row.LeaveFile == null">无</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="Edit(scope.row)" type="text" size="medium">修改</el-button>
                <el-button @click="Delete(scope.row)" type="text" size="medium" style="color: red;">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LeaveList',
    data() {
      return {
        condition: {
          username: '',
          rolelevel: '',
          stuname: '',
          leavesec: '',
          stuno: '',
          stuspec: '',
          token: '',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true,
          secretarysec: ''
        },
        secOptions: [],
        managesecOptions: [],
        tableData: null,
        searchUrl: this.$utils.Url.zpgl + '/api/APILeave/List',
        loading: true
      }
    },
    filters: {
      formatDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        var d = now.getDate()
        return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
      }
    },
    methods: {
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.firstSearch = false
        this.condition.currentPage = val
        this.$refs.btnSearch.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.firstSearch = false
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.$refs.btnSearch.Search()
      },
      Edit: function(row) {
        this.$router.push({
          name: 'LeaveEdit',
          params: {
            id: row.LeaveID
          }
        })
      },
      Delete: function(row) {
        var args = {
          id: row.LeaveID,
          token: this.condition.token
        }
        this.$utils.Delete(this.$utils.Url.zpgl + '/api/APILeave/Delete', args, row.StuName, this.$refs.btnSearch.Search)
      },
      See: function(row) {
        var imgPath = this.$utils.Url.zpgl + '/file/' + row.LeaveFile
        this.$alert('<div style="width:100%;height:300px;"><img src="' + imgPath + '" style="height:300px;"><div>',
          '查看请假凭据', {
            dangerouslyUseHTMLString: true,
            customClass: 'message-box'
          })
      },
      LoadManageSec: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
          that.managesecOptions = data.Data
        }, null, null, null)
      },
      ManageSecChange: function() {
        this.condition.leavesec = ''
        this.secOptions = []
        this.LoadCPSec()
      },
      LoadCPSec: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel,
          mamagesec: this.condition.secretarysec
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/CPSecList', args, function(data) {
          that.secOptions = data.Data
        }, null, null, null)
      },
      UpdateLeaveState: function() {
        this.loading = true
        var args = {
          pageSize: 999,
          currentPage: 1,
        }
        this.$http.post(this.$utils.Url.zpgl + '/api/APILeave/UpdateLeaveState', args)
          .then(res => {
            if (res.data.Code === 0) {
              this.$message({
                message: '数据调整成功',
                type: 'success'
              })
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
            this.loading = false
          })
          .catch(err => {
            console.log(err)
            this.$message({
              message: '数据调整失败',
              type: 'error'
            })
            this.loading = false
          })
      }

    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.condition.username = sessionStorage.getItem('username')
      this.condition.rolelevel = sessionStorage.getItem('rolelevel')
      this.LoadManageSec()
      this.LoadCPSec()
      this.$refs.btnSearch.Search()
    }
  }
</script>

<style scoped="scoped">
  .message-box {
    width: 600px;
  }

  /deep/.el-table .cell {
    line-height: 25px;
  }
</style>
